import React, {Component} from 'react'
import './App.css';
import Landing from './landing/Landing';
import styled from 'styled-components'
import fire from './database/firebase';
import SignUp from './register/SignUp';
import {BrowserRouter as Router, Routes, Route} from 'react-router-dom';
import About from './about/About';


const Styles = styled.div `

    // - - HEADER - -//

`

class App extends Component {
  constructor () {
    super()
    this.state = {
      user: null
    }
  }

  componentDidMount = () => {
    // document.title = "granola notes";
  }


  render () {
    return (
      <Styles>
        {this.state.user ? (
         <Router>
            <Routes>
              {/* <Route exact path = "/" element = {<SignUp/>}/> */}
            </Routes>
         </Router>
        ) : (
          <Router>
            <Routes>
              <Route exact path = "/" element = {<Landing/>}/>
              <Route exact path = "/about" element = {<About/>}/>

              {/* <Route path = "/register" element = {<SignUp/>}/> */}
            </Routes>
          </Router>
        )
        }
        <div>
        </div>
      </Styles>
    )
  }
}

export default App;
